import { createSlice } from '@reduxjs/toolkit';

/**
 * Initial state for pool verification management.
 */
const initialState = {
    poolVerificationList: null,         // List of all pools pending or completed verification
    selectedVerificationPool: null,     // Currently selected pool for verification details or action
    
};

/**
 * Redux slice for managing state related to pool verifications.
 * 
 * Provides actions to update the list and select a specific pool.
 */
const poolVerificationSlice = createSlice({
    name: 'poolVerification',
    initialState,
    reducers: {
        /**
         * Sets the pool verification list.
         * @param {Object} state 
         * @param {Object} action - Array or object representing list of pools.
         */
        setPoolVerificationList: (state, action) => {
            state.poolVerificationList = action.payload;
        },

        /**
         * Sets the selected pool for detailed view or action.
         * @param {Object} state 
         * @param {Object} action - Object containing selected pool data.
         */
        setSelectedVerificationPool: (state, action) => {
            state.selectedVerificationPool = action.payload;
        },
      
    },

    /**
     * Optional global reset support.
     * (Recommended to replace string with formal action.)
     */
    extraReducers: (builder) => {
        builder.addCase('RESET_STATE', () => initialState);
    }
});

// Action exports
export const {
    setPoolVerificationList,
    setSelectedVerificationPool,
} = poolVerificationSlice.actions;

// Reducer export
export default poolVerificationSlice.reducer;
